import { Link, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { ErrorList } from './errorList'
import { BaseResponse } from '../types/base-response'
import { showErrorMessage } from '../redux/reducers/snackbarReducer'
import { AppDispatch } from '../redux/store'

export interface ErrorMessageProps {
  name?: string | RegExp
  description?: string
}

export interface ApiError {
  response: {
    data: BaseResponse
  }
}

function UserDetailedError({ description }: ErrorMessageProps) {
  return <Typography style={{ fontSize: '13px', whiteSpace: 'pre-wrap' }}>{description}</Typography>
}

function ServiceHubMessage({ name }: ErrorMessageProps) {
  const defaultMessage =
    'This action could not be completed. Please raise an issue for investigation via the '
  const url =
    'https://bet365-dwp.onbmc.com/dwp/rest/share/OJSXG33VOJRWKVDZOBST2Q2BKRAUYT2HL5BUCVCFI5HVEWJGORSW4YLOOREWIPKBI5DUQTCQIZEUCMZVIQ3UCUSGKVMFUU2SIZKVQWSTIE3UUNJGOJSXG33VOJRWKSLEHUYTANRQGITHG33VOJRWKVDZOBST2U2CIUTHA4TPOZUWIZLSKNXXK4TDMVHGC3LFHVJUERI='
  let foundItem
  if (typeof name === 'string' && name.indexOf('Days[') >= 0) {
    const idx = name.split('[')[1].split(']')[0]
    if (name === `Days[${idx}].Hours`) {
      foundItem = ErrorList.find(er => `Days[${idx}].Hours`.match(er.name))
    }
  } else {
    foundItem = ErrorList.find(er => er.name === name)
  }
  return (
    <>
      <Typography style={{ fontSize: '13px' }}>
        {foundItem ? foundItem.message : defaultMessage}
        {!foundItem && (
          <Link href={url} target="_blank">
            Service Hub.
          </Link>
        )}
        {foundItem?.link && foundItem.message && (
          <Link href={url} target="_blank">
            Service Hub.
          </Link>
        )}
      </Typography>
    </>
  )
}

function UserErrorMessage({ name, description }: ErrorMessageProps): ReactElement {
  return (
    <>
      {description ? (
        <UserDetailedError description={description} />
      ) : (
        <ServiceHubMessage name={name} />
      )}
    </>
  )
}

export const handleSearchError = (err: ApiError, appDispatch: AppDispatch) => {
  const response: BaseResponse = err.response.data
  response.errors.forEach(error => {
    appDispatch(showErrorMessage(<UserErrorMessage name={error.name} />))
  })
}

export default UserErrorMessage
